import React from 'react'
import { Col, Grid, Row } from 'react-flexbox-grid'
import { Route, Switch } from 'react-router-dom'

import { ReportRouteCostAnalysisViewIndex } from '../../views/ReportsRouteCostAnalysis'
import Header from './Header'
import './styles.scss'

export default class ReportsRouteCostAnalysisLayout extends React.PureComponent {
  render() {
    return (
      <Grid>
        <Row>
          <Col xs={12}>
            <Header />
          </Col>
        </Row>
        <Switch>
          <Route component={ReportRouteCostAnalysisViewIndex} />
        </Switch>
      </Grid>
    )
  }
}
